import { MedicalConfirmNoAnalytics } from '../../../core/actions/analytics/medical_confirm_no_analytics';
import { MedicalConfirmAction } from '../actions/medical_confirm_action';
import { MedicalConfirmYesAnalytics } from '../../../core/actions/analytics/medical_confirm_yes_analytics';

document.addEventListener('DOMContentLoaded', () => {
  MedicalConfirmAction.init();
  /// メディカル業務制御画面 いいえ
  new MedicalConfirmNoAnalytics(); // NOSONAR

  /// メディカル業務制御画面 はい
  new MedicalConfirmYesAnalytics(); // NOSONAR
});
